import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Streams',
  attributeName: 'streams',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'nextId',
      label: 'NEXTID',
      helpText: 'Type of the ingest server.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'videoPublishID',
      helpText: 'VideopublishID',
      type: FormInputTypes.SELECT,
      label: 'VideoPublishID',
      placeholder: 'Add VideoPublish Id fron ingest servers',
      multiple: false,
      url: 'liveGetStreamVideoPublish',
      emptyValue:true,
      fieldValue:'videoPublishID',
      fieldName:'videoPublishID',
      pageId:true,
      asyncSelect: true,
      options:[],
    },
    {
      attributeName: 'audioPublishID',
      type: FormInputTypes.SELECT,
      label: 'Audio publish ID',
      multiple: false,
      url: 'liveGetStreamAudioPublish',
      pageId:true,
      asyncSelect: true,
      emptyValue:true,
      fieldValue:'audioPublishID',
      fieldName:'audioPublishID',
      helpText: 'Set the audio publish Id.',
      errorText: '',
      options:[],
      visibleWhen:[{"field":"deploymentType","value":"ott"}],

    },
    {
      attributeName: 'label',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Label',
      required: true,
      // valueWhen:[{"from":"parent","node":"cameras","field":"name","value":["","concat","left"]}],
      helpText: 'Set the label.',
      errorText: '',
    },
  ]
};
